/* eslint-disable import/namespace */

import classNames from "classnames";
import * as Icons from "react-icons/fi";

import { ReactComponent as VIDLogoDark } from "../../../assets/vid/logos/dark.svg";
import { ReactComponent as VIDLogoFullLight } from "../../../assets/vid/logos/full-light.svg";
import { ReactComponent as VIDLogoLight } from "../../../assets/vid/logos/light.svg";

import styles from "./index.module.scss";

const LOGOS = {
  vidLogoDark: VIDLogoDark,
  vidLogoFullLight: VIDLogoFullLight,
  vidLogoLight: VIDLogoLight,
};

const INTERNAL_BASE = {
  ...LOGOS,
};

export type InternalIconTypes = keyof typeof INTERNAL_BASE;

interface ISvgIconProps {
  type?: keyof typeof Icons;
  internalType?: InternalIconTypes;
  className?: string;
  onClick?: () => void;
}

function SvgIcon({
  type,
  internalType,
  className = "",
  onClick,
}: ISvgIconProps) {
  if (!type && !internalType) {
    return null;
  }

  let IconComponent;

  if (type) {
    IconComponent = Icons[type];
  }

  if (internalType) {
    IconComponent = INTERNAL_BASE[internalType];
  }

  if (!IconComponent) {
    return null;
  }

  const SafeIcon = IconComponent as React.FC<React.SVGProps<SVGSVGElement>>;

  return (
    <SafeIcon
      className={classNames(styles.icon, className)}
      onClick={onClick}
    />
  );
}

export default SvgIcon;
